import React from 'react';

import classNames from 'classnames';

import { appendSearchParams } from 'shared/helpers';
import { Icon } from 'shared/ui';
import { useAppDispatch } from 'store';
import { taskBoardActions } from 'store/slices/taskBoardSlice/taskBoardSlice';

import { Avatar } from './Responsible/Avatar/Avatar';
import cls from './TaskCard.module.css';
import { useTaskCard } from './useTaskCard';
import { TasksBlockType } from '../../../../../model/taskBoard';

interface TaskCardProps {
    classes?: string;
    type: TasksBlockType;
    id: string;
}

export const TaskCard = ({ classes, type, id }: TaskCardProps) => {
    // const titleRef = useRef<HTMLSpanElement>(null);
    // const [isOverflowing, setIsOverflowing] = useState(false);

    const dispatch = useAppDispatch();
    const { task } = useTaskCard(id);
    const isCompleted = task?.completed;

    // useEffect(() => {
    //     const checkOverflow = () => {
    //         if (titleRef.current) {
    //             const isOverflow =
    //                 titleRef.current.scrollWidth > titleRef.current.clientWidth ||
    //                 titleRef.current.scrollHeight > titleRef.current.clientHeight;
    //             setIsOverflowing(isOverflow);
    //         }
    //     };
    //
    //     checkOverflow();
    //     window.addEventListener('resize', checkOverflow);
    //     return () => window.removeEventListener('resize', checkOverflow);
    // }, [task?.title]);

    if (!task) return null;

    const handleTaskCardClick = () => {
        if (task.type === 'system') {
            window.open(task.context.redirect_url, '_blank');
            return;
        }
        const stringUid = task.uid.toString();
        appendSearchParams('task_id', stringUid);
        dispatch(taskBoardActions.onModalMode('editTask'));
    };

    return (
        <div onClick={handleTaskCardClick} className={classNames(cls.TaskCard, [classes])}>
            {task.type === 'system' && (
                <div className={cls.redirect}>
                    <Icon iconName="redirect" />
                </div>
            )}
            <div className={cls.TitleBlock}>
                <Avatar task={task} />

                {/* {isOverflowing && <CustomReactTooltip tooltipId={task.uid} content={task.title} />} */}
                <span
                    className={classNames(cls.TitleText, cls[type], isCompleted && cls.isCompleted)}
                    title={task.title}
                >
                    {task.title}
                </span>
            </div>
            {task.description && (
                <div className={cls.TaskInfo}>
                    <span>{task.description}</span>
                </div>
            )}
            {type !== 'no_term' && (
                <div className={cls.TaskDate}>
                    <Icon
                        iconName="taskCalendar"
                        fill={type === TasksBlockType.OVERDUE ? '#C1281B' : undefined}
                    />
                    {task.date_start && task.date_end ? (
                        <span className={classNames(cls.TaskDateText, cls[type])}>
                            {task.date_start} - {task.date_end}
                        </span>
                    ) : (
                        <span className={classNames(cls.TaskDateText, cls[type])}>
                            {task.date_end}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};
